import { createUseStyles, Styles } from '../../web-styles'

interface StatusPaneStyles {
  container: Styles
  spinStyle: Styles
  button: Styles
}

const CONTAINER_MAX_WIDTH = 320,
  BUTTON_WIDTH = 320

export const useStyles = createUseStyles<StatusPaneStyles>((theme) => {
  return {
    container: {
      maxWidth: theme.calcUnit(CONTAINER_MAX_WIDTH),
      margin: 'auto',
      marginTop: theme.calcUnit(theme.spacing.s10),
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: theme.calcUnit(theme.spacing.s2),
      ...theme.breakpoint.up<Styles>('lg', {
        marginTop: theme.calcUnit(theme.spacing.s16),
      }),
    },
    '@keyframes spin': {
      from: { transform: 'rotate(0deg)' },
      to: { transform: 'rotate(360deg)' },
    },
    spinStyle: {
      animation: '$spin 1s linear infinite',
      display: 'inline-block',
    },
    button: {
      width: '100%',
      maxWidth: theme.calcUnit(BUTTON_WIDTH),
    },
  }
})
